<template lang="html">
    <div id="doom-prices-menu">
        <md-tabs :md-active-tab="activeTab">
            <md-tab id="tab-prices"   v-bind:to="{ name: 'DoomPrices'}"         md-label="Список"></md-tab>
            <md-tab id="tab-settings" v-bind:to="{ name: 'DoomPricesSettings'}" md-label="Настройки"></md-tab>
        </md-tabs>
    </div>
</template>
<script>
    export default {
        name: 'doom-prices-menu',
        data() {
            return {
                activeTab: null
            }
        },
        watch: {
            '$route'() {
                this.activeTab = 'tab-' + this.$route.meta.tab;
            }
        },
        created() {
            this.activeTab = 'tab-' + this.$route.meta.tab;
        }
    }
</script>



// WEBPACK FOOTER //
// DoomPricesMenu.vue?f8d6a40e